<template>
  <!-- Header - Main account summary -->
  <div class="cabinet-console-header">
    <headerUsa></headerUsa>
    <headerUk></headerUk>
    <HeaderForex></HeaderForex>
    <HeaderLatam></HeaderLatam>
    <HeaderMena></HeaderMena>
  </div>
</template>
<script>

/* eslint-disable */

import HeaderUsa from './usa/HeaderUsa.vue';
import HeaderUk from './uk/HeaderUk.vue';
import HeaderForex from './forex/HeaderForex.vue';
import HeaderLatam from './latam/HeaderLatam.vue';
import HeaderMena from './mena/HeaderMena.vue';

export default {
  name: "ConsoleHeader",
  components: {
    HeaderUsa,
    HeaderUk,
    HeaderForex,
    HeaderLatam,
    HeaderMena
  },
}
</script>
